import AppNavbar from "../Navbar/AppNavbar"
import Footer from "../Navbar/Footer";
import '../../assets/css/search.scss';
import searchImg from '../../assets/images/searchContact/search-img.svg'
import { useRef, useState, useCallback, useEffect } from "react";
import { Form, Row, Col, Button, ProgressBar } from 'react-bootstrap';
import Select from 'react-select';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Location from "./Location";
import Company from "./Company";
import Industry from "./Industry";
import Technologies from "./Technologies";
import SelectedSearchFilterTable from "./SelectedSearchFilterTable";
import { useDispatch, useSelector } from "react-redux";
import { getFirstLoginStatus, getToataldataCount, postSaveSearchData } from "../redux/action";
import * as HeaderAuthentication from '../HeaderAuthentication'
import SaveSearchModal from "./SaveSearchModal";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import { jobfunctionOptions, radioOptions, RefData, seniorityOptions, sideMenuItems } from "../CommonFile/DropdownValues";
import { getAisearchedContacts, loadApolloCount, loadViewedIds, postRecentSearchQuery, loadApolloCount1 } from "../redux/ai_connect/ai_action";
import { SearchBtn } from "../Buttons/Buttons";
import { Skeleton } from "@mui/material";
import { toast } from "react-toastify";
import { industryOptions, technologyOptions } from '../CommonFile/DropdownValues';

const ContactFilterCategories = () => {
    const dispatch = useDispatch();
    const refDataVal = RefData();
    const { isAiOpen } = useSelector(state => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;
    const userName = signInDetails[0]?.name;
    const sbnID = signInDetails[0]?.sbn_id;
    const role = signInDetails[0]?.role;
    const { loginStatus } = useSelector(state => state.data);

    const { totalDataCount } = useSelector((state) => state.data);
    const { AisearchedContacts } = useSelector((state) => state.apldata);
    const { viewedContacts } = useSelector((state) => state.apldata);

    const { countryNameDropdown } = useSelector((state) => state.data);

    const { stateDropdownData } = useSelector((state) => state.data);
    const { cityDropdownData } = useSelector((state) => state.data);

    const location = useLocation();
    const [encryptedData, setEncryptedData] = useState("");
    const [paramQuery, setParamQuery] = useState("");

    const [thirdStep, setThirdStep] = useState(true);
    const [forthStep, setForthStep] = useState(false);
    const [fifthStep, setFifthStep] = useState(false);
    const [sixthStep, setSixthStep] = useState(false);

    const [tableHeight, setTableHeight] = useState(0);
    const [activeItem, setActiveItem] = useState("Contact Type");
    const [selected, setSelected] = useState([]);
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [jobTitleInput, setJobTitleInput] = useState('');
    const [jobTitles, setJobTitles] = useState([]);
    const [selectedFunctions, setSelectedFunctions] = useState([]);
    const [search, setSearch] = useState('');

    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [zipCodes, setZipCodes] = useState([]);
    const [zipInput, setZipInput] = useState('');
    const [searchState, setSearchState] = useState('');
    const [hasCompanyEmail, setHasCompanyEmail] = useState({ value: "", label: "" });
    const [hasCompanyMobile, setHasCompanyMobile] = useState({ value: "", label: "" });

    const [companies, setCompanies] = useState([]);
    const [companyInput, setCompanyInput] = useState('');
    const [companySizes, setCompanySizes] = useState([]);
    const [companySizeFrom, setCompanySizeFrom] = useState('');
    const [companySizeTo, setCompanySizeTo] = useState('');
    const [revenues, setRevenues] = useState([]);
    const [revenueFrom, setRevenueFrom] = useState('');
    const [revenueTo, setRevenueTo] = useState('');

    const [sicCode, setSicCode] = useState([]);
    const [selectedIndustries, setSelectedIndustries] = useState([]);
    const [subIndustry, setSubIndustry] = useState([]);
    const [searchSubIndustry, setSearchSubIndustry] = useState('');

    const [lockedProvider, setLockedProvider] = useState(null);
    const [lastProviderUsed, setLastProviderUsed] = useState(null);

    const [selectedTechnology, setSelectedTechnology] = useState([]);
    const [organizationKeywords, setOrganizationKeywords] = useState([]);
    const [searchTechnoloy, setSearchTechnology] = useState('');

    const [totalCount, setTotalCount] = useState(0);
    // const [aiSessionId, setAiSessionId] = useState(null); 
    const [aiSessionId, setAiSessionId] = useState(() => {
        return sessionStorage.getItem("ai_session_id") || null;
    });
    const [loading, setLoading] = useState(false);
    const [loadingSearchContactData, setLoadingSearchContactData] = useState(false);
    const [selectedSort, setSelectedSort] = useState(null);
    const [page, setPage] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);
    const [selectedRowsData, setSelectedRowsData] = useState([]);
    const [selectedRowIds, setSelectedRowIds] = useState({
        type: 'include',
        ids: new Set(),
    });

    const [saveSearchShowModal, setSaveSearchShowModal] = useState(false);
    const [saveSearchName, setSaveSearchName] = useState('');
    const [saveSearchErrorMessage, setSaveSearchErrorMessage] = useState('');
    const [promptVal, setPromptVal] = useState('');
    const [showAddToListModal, setShowAddToListModal] = useState(false);
    const [filterDiv, setFilterDiv] = useState(false);

    const hasRun = useRef(false);
    const hasRun1 = useRef(false);



    // region load viewd ids
    // 
    useEffect(() => {
        if (hasRun1.current) return;
        hasRun1.current = true;
        dispatch(loadViewedIds());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // endregion

    // region function to check url params from saved search
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const dataParam = params.get("data");

        if (isAiOpen) {
            hasRun.current = false;
        }

        if (isAiOpen === false && dataParam) {
            if (hasRun.current) return;
            hasRun.current = true;

            try {
                setEncryptedData(dataParam);
                const secret = "lm_data_param";
                const bytes = CryptoJS.AES.decrypt(dataParam, secret);
                const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

                console.log(decrypted.query, "decrypted.query");
                console.log("Decrypted saved/AI payload =>", decrypted);

                if (decrypted.provider) {
                    const p = String(decrypted.provider).toLowerCase();
                    setLastProviderUsed(p);
                    setLockedProvider(p);
                    sessionStorage.setItem("last_provider_used", p);
                }

                setParamQuery(decrypted);
                setPromptVal(decrypted.query);

                setPage(1);



                // Save session from AI page
                if (decrypted.session_id) {
                    setAiSessionId(decrypted.session_id);
                    sessionStorage.setItem("ai_session_id", decrypted.session_id);
                }
                else {
                    setAiSessionId(null);
                    sessionStorage.removeItem("ai_session_id");
                }
                dispatch(getAisearchedContacts([]));
                viewDataBySavedSearch("results", decrypted, 1, decrypted.session_id ? decrypted.session_id : null);
            } catch (err) {
                console.error("Decryption failed", err);
            }
        } else if (!dataParam) {
            setEncryptedData("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAiOpen, location.search]);

    // useEffect(() => {

    //     if (paramQuery) {
    //         try {
    //             // console(decrypted.query)
    //             const query = paramQuery.query.toLowerCase();
    //             // alert(query)
    //             const cityMatch = query.match(/location:\s*([^\n]+)/i);
    //             const job_levelMatch = query.match(/seniorities:\s*([^\n]+)/i);
    //             const job_departmentMatch = query.match(/job functions:\s*([^\n]+)/i);
    //             const titleMatch = query.match(/titles:\s*([^\n]+)/i);
    //             const zip_codeMatch = query.match(/zip code:\s*([^\n]+)/i);
    //             const compsnyMatch = query.match(/companies:\s*([^\n]+)/i);
    //             const compsnySizeMatch = query.match(/companie size:\s*([^\n]+)/i);
    //             const revenueMatch = query.match(/revenue:\s*([^\n]+)/i);
    //             const industryMatch = query.match(/industries:\s*([^\n]+)/i);
    //             const sicMatch = query.match(/sic codes:\s*([^\n]+)/i);
    //             const techMatch = query.match(/technologies:\s*([^\n]+)/i);
    //             const emailMatch = query.match(/having email:\s*([^\n]+)/i);
    //             const phoneMatch = query.match(/having phone:\s*([^\n]+)/i);


    //             const cityValue = cityMatch?.[1]?.trim();
    //             const levelValue = job_levelMatch?.[1]?.trim();
    //             const deptValue = job_departmentMatch?.[1]?.trim();
    //             const titleValue = titleMatch?.[1]?.trim();
    //             const zipcodeValue = zip_codeMatch?.[1]?.trim();
    //             const companyValue = compsnyMatch?.[1]?.trim();
    //             const compsnySizeValue = compsnySizeMatch?.[1]?.trim();
    //             const revenueValue = revenueMatch?.[1]?.trim();
    //             const industryValue = industryMatch?.[1]?.trim();
    //             const sicValue = sicMatch?.[1]?.trim();
    //             const techValue = techMatch?.[1]?.trim();
    //             const emailValue = emailMatch?.[1]?.trim();
    //             const phoneValue = phoneMatch?.[1]?.trim();
    //             if (emailValue) {
    //                 setHasCompanyEmail({ value: emailValue, label: emailValue })
    //             }
    //             if (phoneValue) {
    //                 setHasCompanyMobile({ value: phoneValue, label: phoneValue })
    //             }

    //             if (countryNameDropdown.length !== 0 && cityValue) {
    //                 let locations = cityValue.split(",")
    //                 countryNameDropdown.forEach((item, i) => {
    //                     if (locations.includes(item.label.trim().toLocaleLowerCase())) {
    //                         setCountries(prev => {
    //                             const exists = prev.some(
    //                                 country => country.label === item.label
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (stateDropdownData.length !== 0 && cityValue) {
    //                 let locations = cityValue.split(",")
    //                 stateDropdownData.forEach((item, i) => {
    //                     if (locations.includes(item.label.trim().toLocaleLowerCase())) {
    //                         setStates(prev => {
    //                             const exists = prev.some(
    //                                 state => state.label === item.label
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (cityDropdownData.length !== 0 && cityValue) {
    //                 let locations = cityValue.split(",")
    //                 cityDropdownData.forEach((item) => {
    //                     if (locations.includes(item.label.trim().toLocaleLowerCase())) {
    //                         setCities(prev => {
    //                             const exists = prev.some(
    //                                 city => city.label === item.label
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (seniorityOptions.length !== 0 && levelValue) {
    //                 let levels = levelValue.split(",")
    //                 seniorityOptions.forEach((item) => {
    //                     if (levels.includes(item.label.trim().toLocaleLowerCase())) {
    //                         setSelected(prev => {
    //                             const exists = prev.some(
    //                                 lvl => lvl === item.label
    //                             );

    //                             return exists ? prev : [...prev, item.label];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (jobfunctionOptions.length !== 0 && deptValue) {
    //                 let levels = deptValue.split(",")
    //                 jobfunctionOptions.forEach((item) => {
    //                     if (levels.includes(item.label.trim().toLocaleLowerCase())) {
    //                         setSelectedFunctions(prev => {
    //                             const exists = prev.some(
    //                                 fun => fun === item.label
    //                             );

    //                             return exists ? prev : [...prev, item.label];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (titleValue) {
    //                 let levels = titleValue.split(",")
    //                 levels.forEach((item) => {
    //                     if (item) {
    //                         setJobTitles(prev => {
    //                             const exists = prev.some(
    //                                 title => title === item
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (titleValue) {
    //                 let levels = titleValue.split(",")
    //                 levels.forEach((item) => {
    //                     if (item) {
    //                         setJobTitles(prev => {
    //                             const exists = prev.some(
    //                                 title => title === item
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (zipcodeValue) {
    //                 let zipCode = zipcodeValue.split(",")
    //                 zipCode.forEach((item) => {
    //                     if (item) {
    //                         setZipCodes(prev => {
    //                             const exists = prev.some(
    //                                 zip => zip === item
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (companyValue) {
    //                 let companies = companyValue.split(",")
    //                 companies.forEach((item) => {
    //                     if (item) {
    //                         setCompanies(prev => {
    //                             const exists = prev.some(
    //                                 comp => comp === item
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (compsnySizeValue) {
    //                 let companySize = compsnySizeValue.split(",")
    //                 companySize.forEach((item) => {
    //                     if (item) {
    //                         setCompanySizes(prev => {
    //                             const exists = prev.some(
    //                                 size => size === item
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (revenueValue) {
    //                 let revenues = revenueValue.split(",")
    //                 revenues.forEach((item) => {
    //                     if (item) {
    //                         setRevenues(prev => {
    //                             const exists = prev.some(
    //                                 rev => rev === item
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (industryOptions.length !== 0 && industryValue) {
    //                 let levels = industryValue.split(",")
    //                 industryOptions.forEach((item) => {
    //                     if (levels.includes(item.label.trim().toLocaleLowerCase())) {
    //                         setSelectedIndustries(prev => {
    //                             const exists = prev.some(
    //                                 industry => industry === item.label
    //                             );

    //                             return exists ? prev : [...prev, item.label];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (sicValue) {
    //                 let sicData = sicValue.split(",")
    //                 sicData.forEach((item) => {
    //                     if (item) {
    //                         setSicCode(prev => {
    //                             const exists = prev.some(
    //                                 sic => sic === item
    //                             );

    //                             return exists ? prev : [...prev, item];
    //                         });
    //                     }
    //                 })
    //             }
    //             if (techValue) {
    //                 let techValues = techValue.split(",")
    //                 technologyOptions.forEach((item) => {
    //                     if (techValues.includes(item.label.trim().toLocaleLowerCase())) {
    //                         setSelectedTechnology(prev => {
    //                             const exists = prev.some(
    //                                 tech => tech === item.label
    //                             );

    //                             return exists ? prev : [...prev, item.label];
    //                         });
    //                     }
    //                 })
    //             }


    //         } catch (err) {
    //             console.error("Decryption failed", err);
    //         }
    //     }

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [paramQuery, countryNameDropdown, stateDropdownData, cityDropdownData, industryOptions]);
    // endregion

    useEffect(() => {
        if (!paramQuery) return;

        let filters = null;

        // 1. Prefer structured filters coming from AI
        if (paramQuery.filters && Object.keys(paramQuery.filters).length > 0) {
            filters = mapAiFiltersToManual(paramQuery.filters) || paramQuery.filters;
        }

        // 2. Fallback – parse from natural language / structured prompt
        if (!filters) {
            filters = parseFiltersFromPrompt(paramQuery.query || "");
        }

        console.log("HYDRATE UI FILTERS =>", filters);   // for debugging
        hydrateUiFilters(filters);
    }, [paramQuery, countryNameDropdown, stateDropdownData, cityDropdownData]);

    // region function to call data api from saved search query 
    // const viewDataBySavedSearch = (resultype, decrypted, forcedPage = null, forcedSessionId = undefined) => {
    //     const pageToUse = forcedPage ?? page;
    //     if (resultype === "results") {
    //         console.log("Saved Search Called")
    //         setViewResult(true);
    //         if (page === 1) {
    //             setLoading(true);
    //             dispatch(getAisearchedContacts([]));
    //             setLoadingSearchContactData(true);
    //         }
    //     }

    //     const sessionToUse =
    //         forcedSessionId !== undefined
    //             ? forcedSessionId
    //             : (decrypted.session_id ||
    //                 aiSessionId ||
    //                 sessionStorage.getItem("ai_session_id") ||
    //                 null);
    //     const query = (decrypted.query || "").toLowerCase();

    //     const getMatch = (label) => {
    //         const m = query.match(new RegExp(`${label}:\\s*([^\\n]+)`, "i"));
    //         return m?.[1]?.trim() || "";
    //     };

    //     const splitValues = (str) =>
    //         str ? str.split(",").map((s) => s.trim()).filter(Boolean) : [];

    //     const locationStr = getMatch("location");
    //     const locationParts = splitValues(locationStr);

    //     const filters = {
    //         countries: locationParts,           // backend often accepts mixed location list
    //         states: locationParts,
    //         cities: locationParts,
    //         zip_codes: splitValues(getMatch("zip code")),
    //         seniorities: splitValues(getMatch("seniorities")),
    //         job_functions: splitValues(getMatch("job functions")),
    //         titles: splitValues(getMatch("titles")),
    //         companies: splitValues(getMatch("companies")),
    //         company_sizes: splitValues(getMatch("company size") || getMatch("companie size")),
    //         revenues: splitValues(getMatch("revenue")),
    //         industries: splitValues(getMatch("industries")),
    //         sic_codes: splitValues(getMatch("sic codes")),
    //         technologies: splitValues(getMatch("technologies")),
    //         has_email: getMatch("having email") || null,
    //         has_phone: getMatch("having phone") || null,
    //     };

    //     const payload = {
    //         prompt: decrypted.query,
    //         // session_id:
    //         //     decrypted.session_id ||
    //         //     aiSessionId ||
    //         //     sessionStorage.getItem("ai_session_id") ||
    //         //     decrypted.session_id ||
    //         //     null, 
    //         session_id: sessionToUse,
    //         search_type: "manual",
    //         filters: filters,
    //         run_search: true,
    //         page: pageToUse,
    //         page_size: 100,
    //         provider: null,
    //         provider_page: {},
    //         mode: "results",
    //         uid: parseInt(signInID),
    //         role: role,
    //         sbn_id: sbnID,
    //     };

    //     console.log("SAVED SEARCH PAYLOAD =>", payload);

    //     const requestOption = {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify(payload),
    //     };

    //     dispatch(loadApolloCount1(requestOption, resultype))
    //         .then((resp) => {
    //             if (resultype === "count") {
    //                 setTotalCount(resp.count);
    //                 dispatch(getToataldataCount(resp.count || 0));
    //                 if (resp.session_id) {
    //                     setAiSessionId(resp.session_id);
    //                     sessionStorage.setItem("ai_session_id", resp.session_id);
    //                 }
    //                 setLoading(false);
    //             } else {
    //                 const providerUsed =
    //                     resp.provider_used ||
    //                     resp.results?.provider_used ||
    //                     (resp.results?.salestarget?.length ? "salestarget" : "apollo");

    //                 const rawList =
    //                     (resp.results?.apollo && resp.results.apollo.length
    //                         ? resp.results.apollo
    //                         : resp.results?.salestarget) || [];

    //                 const mergedData = rawList.map((item) => {
    //                     const matched = viewedContacts.find(
    //                         (v) => item.id === v.source_id && v.enrich_status === 1
    //                     );

    //                     let email = item.email;
    //                     let hasEmail = item.has_email;

    //                     if (
    //                         email === "***@***.com" ||
    //                         (typeof email === "string" && email.startsWith("***@"))
    //                     ) {
    //                         email = null;
    //                         hasEmail = true;
    //                     } else if (email) {
    //                         hasEmail = true;
    //                     } else {
    //                         hasEmail = false;
    //                     }

    //                     const row = matched
    //                         ? {
    //                             ...item,
    //                             email: matched.email,
    //                             phone: matched.phone,
    //                             state: matched.state,
    //                             city: matched.city,
    //                             country: matched.country,
    //                             zipcode: matched.zipcode,
    //                             saved_status: true,
    //                             has_email: true,
    //                         }
    //                         : {
    //                             ...item,
    //                             email,
    //                             has_email: hasEmail,
    //                             saved_status: false,
    //                         };

    //                     return {
    //                         ...row,
    //                         provider: item.provider || providerUsed || "apollo",
    //                     };
    //                 });

    //                 const totalAvailable =
    //                     resp.pagination?.apollo?.total_available ??
    //                     resp.pagination?.salestarget?.total_available ??
    //                     resp.count ??
    //                     0;

    //                 setTotalCount(totalAvailable);
    //                 dispatch(getToataldataCount(totalAvailable));

    //                 if (resp.session_id) {
    //                     setAiSessionId(resp.session_id);
    //                     sessionStorage.setItem("ai_session_id", resp.session_id);
    //                 }

    //                 setLoading(false);
    //                 dispatch(getAisearchedContacts(mergedData));
    //                 setLoadingSearchContactData(false);
    //                 setLoadingMore(false);
    //             }
    //         })
    //         .catch((err) => {
    //             setLoading(false);
    //             console.log(err);
    //         });
    // };  

    // Parses both:
    // A) Structured saved-search prompt:
    //    Location: bengaluru, karnataka, india
    //    Seniorities: entry
    //    Titles: Python Developer
    // B) Simple AI natural-language prompt:
    //    Find Python Developers in Bengaluru, India
    //    Seniority: Entry 

    // const hydrateUiFilters = (filters) => {
    //     if (!filters) return;

    //     // Titles
    //     if (filters.titles?.length) {
    //         setJobTitles(prev => {
    //             const next = [...prev];
    //             filters.titles.forEach(t => {
    //                 if (t && !next.includes(t)) next.push(t);
    //             });
    //             return next;
    //         });
    //     }

    //     // Countries / States / Cities
    //     if (filters.countries?.length && countryNameDropdown?.length) {
    //         filters.countries.forEach(c => {
    //             const match = countryNameDropdown.find(
    //                 item => item.label.toLowerCase() === String(c).toLowerCase()
    //             );
    //             if (match) {
    //                 setCountries(prev =>
    //                     prev.some(x => x.label === match.label) ? prev : [...prev, match]
    //                 );
    //             }
    //         });
    //     }

    //     if (filters.states?.length && stateDropdownData?.length) {
    //         filters.states.forEach(s => {
    //             const match = stateDropdownData.find(
    //                 item => item.label.toLowerCase() === String(s).toLowerCase()
    //             );
    //             if (match) {
    //                 setStates(prev =>
    //                     prev.some(x => x.label === match.label) ? prev : [...prev, match]
    //                 );
    //             }
    //         });
    //     }

    //     // if (filters.cities?.length && cityDropdownData?.length) {
    //     //     filters.cities.forEach(c => {
    //     //         // handle "Chennai, IN" → try "Chennai"
    //     //         const cityName = String(c).split(",")[0].trim();
    //     //         const match = cityDropdownData.find(
    //     //             item => item.label.toLowerCase() === cityName.toLowerCase()
    //     //         );
    //     //         if (match) {
    //     //             setCities(prev =>
    //     //                 prev.some(x => x.label === match.label) ? prev : [...prev, match]
    //     //             );
    //     //         }
    //     //     });
    //     // } 

    //     // Cities – clean "Bengaluru, KA, IN" → "Bengaluru"
    //     // Cities – always clean first
    //     if (filters.cities?.length) {
    //         filters.cities.forEach(c => {
    //             const cityName = String(c).split(",")[0].trim();
    //             if (!cityName) return;

    //             if (cityDropdownData?.length) {
    //                 const match = cityDropdownData.find(
    //                     item => item.label.toLowerCase() === cityName.toLowerCase()
    //                 );
    //                 if (match) {
    //                     setCities(prev =>
    //                         prev.some(x => x.label === match.label) ? prev : [...prev, match]
    //                     );
    //                     return;
    //                 }
    //             }

    //             // Fallback – show cleaned name even if not in dropdown
    //             setCities(prev => {
    //                 const exists = prev.some(
    //                     x => (x.label || x).toLowerCase() === cityName.toLowerCase()
    //                 );
    //                 return exists ? prev : [...prev, { label: cityName, value: cityName }];
    //             });
    //         });
    //     }

    //     // Seniorities
    //     if (filters.seniorities?.length) {
    //         setSelected(prev => {
    //             const next = [...prev];
    //             filters.seniorities.forEach(s => {
    //                 if (s && !next.includes(s.toLowerCase())) next.push(s.toLowerCase());
    //             });
    //             return next;
    //         });
    //     }

    //     // Job Functions
    //     if (filters.job_functions?.length) {
    //         setSelectedFunctions(prev => {
    //             const next = [...prev];
    //             filters.job_functions.forEach(f => {
    //                 if (f && !next.includes(f.toLowerCase())) next.push(f.toLowerCase());
    //             });
    //             return next;
    //         });
    //     }

    //     // Company size (organization_num_employees_ranges)
    //     if (filters.company_sizes?.length || filters.organization_num_employees_ranges?.length) {
    //         const sizes = filters.company_sizes || filters.organization_num_employees_ranges;
    //         setCompanySizes(prev => {
    //             const next = [...prev];
    //             sizes.forEach(s => {
    //                 if (s && !next.includes(s)) next.push(s);
    //             });
    //             return next;
    //         });
    //     }

    //     // has_email / has_phone
    //     if (filters.has_email) {
    //         setHasCompanyEmail({ value: filters.has_email, label: filters.has_email });
    //     }
    //     if (filters.has_phone) {
    //         setHasCompanyMobile({ value: filters.has_phone, label: filters.has_phone });
    //     }
    // }; 

    const hydrateUiFilters = (filters) => {
        if (!filters) return;

        console.log("========== HYDRATE UI FILTERS ==========");
        console.log("Filters received =>", filters);

        // --------------------------------------------------
        // JOB TITLE
        // --------------------------------------------------
        if (filters.titles?.length) {
            setJobTitles(prev => {
                const next = [...prev];

                filters.titles.forEach(title => {
                    const value = String(title || "").trim();

                    if (
                        value &&
                        !next.some(
                            item =>
                                String(item).toLowerCase() === value.toLowerCase()
                        )
                    ) {
                        next.push(value);
                    }
                });

                return next;
            });
        }

        // --------------------------------------------------
        // COUNTRY
        // --------------------------------------------------
        if (filters.countries?.length) {
            filters.countries.forEach(country => {
                const countryName = String(country || "").trim();

                if (!countryName) return;

                const match = countryNameDropdown?.find(
                    item =>
                        String(item.label || "").trim().toLowerCase() ===
                        countryName.toLowerCase()
                );

                setCountries(prev => {
                    const exists = prev.some(
                        item =>
                            String(item.label || item)
                                .trim()
                                .toLowerCase() === countryName.toLowerCase()
                    );

                    if (exists) return prev;

                    return [
                        ...prev,
                        match || {
                            label: countryName,
                            value: countryName
                        }
                    ];
                });
            });
        }

        // --------------------------------------------------
        // STATE
        // --------------------------------------------------
        if (filters.states?.length) {
            filters.states.forEach(state => {
                const stateName = String(state || "").trim();

                if (!stateName) return;

                const match = stateDropdownData?.find(
                    item =>
                        String(item.label || "").trim().toLowerCase() ===
                        stateName.toLowerCase()
                );

                setStates(prev => {
                    const exists = prev.some(
                        item =>
                            String(item.label || item)
                                .trim()
                                .toLowerCase() === stateName.toLowerCase()
                    );

                    if (exists) return prev;

                    return [
                        ...prev,
                        match || {
                            label: stateName,
                            value: stateName
                        }
                    ];
                });
            });
        }

        // --------------------------------------------------
        // CITY
        // --------------------------------------------------
        if (filters.cities?.length) {
            filters.cities.forEach(city => {

                // Handles:
                // Chennai
                // Chennai, TN, IN
                // Chennai, Tamil Nadu, India

                const cityName = String(city || "")
                    .split(",")[0]
                    .trim();

                if (!cityName) return;

                const match = cityDropdownData?.find(
                    item =>
                        String(item.label || "").trim().toLowerCase() ===
                        cityName.toLowerCase()
                );

                setCities(prev => {
                    const exists = prev.some(
                        item =>
                            String(item.label || item)
                                .trim()
                                .toLowerCase() === cityName.toLowerCase()
                    );

                    if (exists) return prev;

                    return [
                        ...prev,
                        match || {
                            label: cityName,
                            value: cityName
                        }
                    ];
                });
            });
        }

        // --------------------------------------------------
        // SENIORITY / CONTACT LEVEL
        // --------------------------------------------------
        if (filters.seniorities?.length) {
            setSelected(prev => {
                const next = [...prev];

                filters.seniorities.forEach(level => {
                    const value = String(level || "")
                        .trim()
                        .toLowerCase();

                    if (
                        value &&
                        !next.some(
                            item =>
                                String(item).toLowerCase() === value
                        )
                    ) {
                        next.push(value);
                    }
                });

                return next;
            });
        }

        // --------------------------------------------------
        // JOB FUNCTION
        // --------------------------------------------------
        if (filters.job_functions?.length) {
            setSelectedFunctions(prev => {
                const next = [...prev];

                filters.job_functions.forEach(func => {
                    const value = String(func || "")
                        .trim()
                        .toLowerCase();

                    if (
                        value &&
                        !next.includes(value)
                    ) {
                        next.push(value);
                    }
                });

                return next;
            });
        }

        // --------------------------------------------------
        // COMPANY
        // --------------------------------------------------
        if (filters.companies?.length) {
            setCompanies(prev => {
                const next = [...prev];

                filters.companies.forEach(company => {
                    const value = String(company || "").trim();

                    if (
                        value &&
                        !next.some(
                            item =>
                                String(item).toLowerCase() ===
                                value.toLowerCase()
                        )
                    ) {
                        next.push(value);
                    }
                });

                return next;
            });
        }

        // --------------------------------------------------
        // COMPANY SIZE
        // --------------------------------------------------
        if (
            filters.company_sizes?.length ||
            filters.organization_num_employees_ranges?.length
        ) {
            const sizes =
                filters.company_sizes ||
                filters.organization_num_employees_ranges ||
                [];

            setCompanySizes(prev => {
                const next = [...prev];

                sizes.forEach(size => {
                    const value = String(size || "").trim();

                    if (value && !next.includes(value)) {
                        next.push(value);
                    }
                });

                return next;
            });
        }

        // --------------------------------------------------
        // EMAIL / PHONE
        // --------------------------------------------------
        if (filters.has_email) {
            setHasCompanyEmail({
                value: filters.has_email,
                label: filters.has_email
            });
        }

        if (filters.has_phone) {
            setHasCompanyMobile({
                value: filters.has_phone,
                label: filters.has_phone
            });
        }

        console.log("========================================");
    };

    const parseFiltersFromPrompt = (rawQuery = "") => {
        const query = String(rawQuery || "").trim();
        const queryLower = query.toLowerCase();

        // Only treat as empty when the prompt has NOTHING useful after the header
        const withoutHeader = queryLower
            .replace(/^get contacts for below criteria\s*/i, "")
            .trim();

        if (!query || !withoutHeader) {
            return {
                countries: [],
                states: [],
                cities: [],
                zip_codes: [],
                seniorities: [],
                job_functions: [],
                titles: [],
                companies: [],
                company_sizes: [],
                revenues: [],
                industries: [],
                sic_codes: [],
                technologies: [],
                has_email: null,
                has_phone: null,
            };
        }

        // Parse from the full query (including lines after the header)
        const getMatch = (label) => {
            const m = query.match(new RegExp(`${label}:\\s*([^\\n]+)`, "i"));
            return m?.[1]?.trim() || "";
        };

        const splitValues = (str) =>
            str
                ? str
                    .split(",")
                    .map((s) => s.trim())
                    .filter(Boolean)
                : [];

        let titles = splitValues(getMatch("titles"));
        let seniorities = splitValues(
            getMatch("seniorities") || getMatch("seniority")
        );
        let locationParts = splitValues(getMatch("location"));
        let jobFunctions = splitValues(getMatch("job functions"));
        let companies = splitValues(getMatch("companies"));
        let companySizes = splitValues(
            getMatch("company size") || getMatch("companie size")
        );
        let revenues = splitValues(getMatch("revenue"));
        let industries = splitValues(getMatch("industries"));
        let sicCodes = splitValues(getMatch("sic codes"));
        let technologies = splitValues(
            getMatch("technologies") || getMatch("skills")
        );
        let zipCodes = splitValues(getMatch("zip code"));
        let hasEmail = getMatch("having email") || null;
        let hasPhone = getMatch("having phone") || null;

        // AI natural-language fallbacks (only when structured lines are missing)
        if (titles.length === 0) {
            const m =
                query.match(
                    /(?:find|get|show|search)\s+(.+?)\s+(?:in|at|from|near)\s+/i
                ) ||
                query.match(/(?:find|get|show|search)\s+(.+?)(?:\.|$)/i);
            if (m?.[1]) {
                let t = m[1]
                    .replace(/\bdevelopers?\b/gi, "Developer")
                    .replace(/\bengineers?\b/gi, "Engineer")
                    .replace(/\bmanagers?\b/gi, "Manager")
                    .trim();
                if (
                    t &&
                    !t.includes("below criteria") &&
                    !t.includes("contacts for")
                ) {
                    titles = [t];
                }
            }
        }

        if (locationParts.length === 0) {
            const m = query.match(
                /\bin\s+([a-zA-Z\s,]+?)(?:\.|$|,?\s*seniorit)/i
            );
            if (m?.[1]) {
                locationParts = splitValues(m[1]);
            }
        }

        //     if (seniorities.length === 0) {
        //         const m = query.match(
        //             /seniorit(?:y|ies)\s*:?\s*([a-zA-Z\s\-]+)/i
        //         );
        //         if (m?.[1]) {
        //             seniorities = splitValues(m[1]);
        //         }
        //     }

        //     const looksLikeCountry = (s) => {
        //         const t = String(s || "").trim().toLowerCase();
        //         if (!t) return false;
        //         const countries = new Set([
        //             "india", "united states", "usa", "us", "united kingdom", "uk",
        //             "uae", "canada", "australia", "singapore", "germany", "france",
        //         ]);
        //         return countries.has(t) || t.length <= 3; // IN, US, UK
        //     };

        //     const looksLikeCompoundLocation = (s) => {
        //         // "India, KA, IN" or "Bengaluru, Karnataka, India"
        //         return String(s || "").includes(",");
        //     };

        //     // After you build cities / states / countries:
        //     cities = cities.filter(
        //         (c) => !looksLikeCountry(c) && !looksLikeCompoundLocation(c)
        //     );
        //     states = states.filter(
        //         (s) => !looksLikeCountry(s) && !looksLikeCompoundLocation(s)
        //     );

        //     return {
        //         countries: locationParts,
        //         states: locationParts,
        //         cities: locationParts,
        //         zip_codes: zipCodes,
        //         seniorities,
        //         job_functions: jobFunctions,
        //         titles,
        //         companies,
        //         company_sizes: companySizes,
        //         revenues,
        //         industries,
        //         sic_codes: sicCodes,
        //         technologies,
        //         has_email: hasEmail,
        //         has_phone: hasPhone,
        //     };
        // }; 
        if (seniorities.length === 0) {
            const m = query.match(
                /seniorit(?:y|ies)\s*:?\s*([a-zA-Z\s\-]+)/i
            );
            if (m?.[1]) {
                seniorities = splitValues(m[1]);
            }
        }

        // ----- split location into country / state / city (local vars only) -----
        const looksLikeCountry = (s) => {
            const t = String(s || "").trim().toLowerCase();
            if (!t) return false;
            const list = new Set([
                "india", "united states", "usa", "us", "united kingdom", "uk",
                "uae", "canada", "australia", "singapore", "germany", "france",
            ]);
            return list.has(t) || ["in", "us", "uk", "uae"].includes(t);
        };

        const looksLikeCompoundLocation = (s) =>
            String(s || "").includes(",");

        let locCountries = [];
        let locStates = [];
        let locCities = [];

        const parts = (locationParts || [])
            .map((p) => String(p).trim())
            .filter(Boolean);

        if (parts.length === 1) {
            const p = parts[0];
            if (looksLikeCompoundLocation(p)) {
                // e.g. "India, KA, IN" or "Bengaluru, Karnataka, India"
                const sub = p.split(",").map((x) => x.trim()).filter(Boolean);
                if (sub.length >= 3) {
                    locCities.push(sub[0]);
                    locStates.push(sub[1]);
                    locCountries.push(sub[sub.length - 1]);
                } else if (sub.length === 2) {
                    if (looksLikeCountry(sub[1])) {
                        locCountries.push(sub[1]);
                        if (!looksLikeCountry(sub[0])) locCities.push(sub[0]);
                    } else {
                        locCities.push(sub[0]);
                        locStates.push(sub[1]);
                    }
                } else if (sub.length === 1 && looksLikeCountry(sub[0])) {
                    locCountries.push(sub[0]);
                }
            } else if (looksLikeCountry(p)) {
                locCountries.push(p);
            } else {
                locCities.push(p);
            }
        } else if (parts.length === 2) {
            const [a, b] = parts;
            if (looksLikeCountry(b)) {
                locCountries.push(b);
                if (!looksLikeCountry(a)) locCities.push(a);
            } else if (looksLikeCountry(a)) {
                locCountries.push(a);
                if (!looksLikeCountry(b)) locCities.push(b);
            } else {
                locCities.push(a);
                locStates.push(b);
            }
        } else if (parts.length >= 3) {
            locCountries.push(parts[parts.length - 1]);
            locStates.push(parts[parts.length - 2]);
            locCities.push(parts.slice(0, -2).join(" "));
        }

        // strip bad values (never put country string into city)
        locCities = locCities.filter(
            (c) => c && !looksLikeCountry(c) && !looksLikeCompoundLocation(c)
        );
        locStates = locStates.filter(
            (s) => s && !looksLikeCountry(s) && !looksLikeCompoundLocation(s)
        );
        locCountries = locCountries.filter(Boolean);

        return {
            countries: locCountries,
            states: locStates,
            cities: locCities,
            zip_codes: zipCodes,
            seniorities,
            job_functions: jobFunctions,
            titles,
            companies,
            company_sizes: companySizes,
            revenues,
            industries,
            sic_codes: sicCodes,
            technologies,
            has_email: hasEmail,
            has_phone: hasPhone,
        };
    };

    // const mapAiFiltersToManual = (aiFilters = {}) => {
    //     if (!aiFilters || typeof aiFilters !== "object") return null;

    //     const titles =
    //         aiFilters.jobTitle ||
    //         aiFilters.titles ||
    //         aiFilters.person_titles ||
    //         [];
    //     const countries =
    //         aiFilters.country || aiFilters.countries || [];
    //     const states =
    //         aiFilters.state || aiFilters.states || [];
    //     const cities =
    //         aiFilters.city || aiFilters.cities || [];
    //     const seniorities =
    //         aiFilters.seniority ||
    //         aiFilters.seniorities ||
    //         aiFilters.jobLevel ||
    //         [];
    //     const technologies =
    //         aiFilters.skills ||
    //         aiFilters.technologies ||
    //         [];

    //     const hasAny =
    //         (Array.isArray(titles) && titles.length) ||
    //         (Array.isArray(countries) && countries.length) ||
    //         (Array.isArray(cities) && cities.length) ||
    //         (Array.isArray(seniorities) && seniorities.length) ||
    //         (Array.isArray(technologies) && technologies.length);

    //     if (!hasAny) return null;

    //     return {
    //         countries: Array.isArray(countries) ? countries : [countries].filter(Boolean),
    //         states: Array.isArray(states) ? states : [states].filter(Boolean),
    //         cities: Array.isArray(cities) ? cities : [cities].filter(Boolean),
    //         zip_codes: aiFilters.zip_codes || [],
    //         seniorities: Array.isArray(seniorities)
    //             ? seniorities
    //             : [seniorities].filter(Boolean),
    //         job_functions: aiFilters.job_functions || [],
    //         titles: Array.isArray(titles) ? titles : [titles].filter(Boolean),
    //         companies: aiFilters.companies || aiFilters.companyName || [],
    //         company_sizes: aiFilters.company_sizes || aiFilters.companySize || [],
    //         revenues: aiFilters.revenues || [],
    //         industries: aiFilters.industries || aiFilters.industry || [],
    //         sic_codes: aiFilters.sic_codes || [],
    //         technologies: Array.isArray(technologies)
    //             ? technologies
    //             : [technologies].filter(Boolean),
    //         has_email: aiFilters.has_email ?? aiFilters.hasEmail ?? null,
    //         has_phone: aiFilters.has_phone ?? aiFilters.hasPhone ?? null,
    //     };
    // }; 

    const mapAiFiltersToManual = (aiFilters = {}) => {
        if (!aiFilters || typeof aiFilters !== "object") {
            return null;
        }

        const toArray = (value) => {
            if (Array.isArray(value)) {
                return value.filter(Boolean);
            }

            if (value === null || value === undefined || value === "") {
                return [];
            }

            return [value];
        };

        const titles = toArray(
            aiFilters.jobTitle ??
            aiFilters.job_title ??
            aiFilters.titles ??
            aiFilters.person_titles
        );

        const countries = toArray(
            aiFilters.country ??
            aiFilters.countryName ??
            aiFilters.countries
        );

        const states = toArray(
            aiFilters.state ??
            aiFilters.stateName ??
            aiFilters.states
        );

        const cities = toArray(
            aiFilters.city ??
            aiFilters.cityName ??
            aiFilters.cities
        );

        const seniorities = toArray(
            aiFilters.seniority ??
            aiFilters.seniorities ??
            aiFilters.jobLevel ??
            aiFilters.job_level
        );

        const technologies = toArray(
            aiFilters.skills ??
            aiFilters.technologies
        );

        const filters = {
            countries,
            states,
            cities,
            zip_codes: toArray(aiFilters.zip_codes),
            seniorities,
            job_functions: toArray(aiFilters.job_functions),
            titles,
            companies: toArray(
                aiFilters.companies ??
                aiFilters.companyName
            ),
            company_sizes: toArray(
                aiFilters.company_sizes ??
                aiFilters.companySize
            ),
            revenues: toArray(aiFilters.revenues),
            industries: toArray(
                aiFilters.industries ??
                aiFilters.industry
            ),
            sic_codes: toArray(aiFilters.sic_codes),
            technologies,
            has_email: aiFilters.has_email ?? aiFilters.hasEmail ?? null,
            has_phone: aiFilters.has_phone ?? aiFilters.hasPhone ?? null,
        };

        const hasAnyFilter =
            filters.titles.length > 0 ||
            filters.countries.length > 0 ||
            filters.states.length > 0 ||
            filters.cities.length > 0 ||
            filters.seniorities.length > 0 ||
            filters.job_functions.length > 0 ||
            filters.companies.length > 0 ||
            filters.technologies.length > 0;

        return hasAnyFilter ? filters : null;
    };

    // region function to call data api from saved search / AI search
    const viewDataBySavedSearch = (resultype, decrypted, forcedPage = null, forcedSessionId = undefined) => {
        const pageToUse = forcedPage ?? page;

        if (resultype === "results") {
            console.log("Saved / AI Search Called");
            setViewResult(true);
            if (pageToUse === 1) {
                setLoading(true);
                dispatch(getAisearchedContacts([]));
                setLoadingSearchContactData(true);
            }
        }

        // ---------- session ----------
        // Prefer explicit forcedSessionId (including null).
        // Otherwise use session from decrypted payload / state / storage.
        const sessionToUse =
            forcedSessionId !== undefined
                ? forcedSessionId
                : (decrypted?.session_id ||
                    aiSessionId ||
                    sessionStorage.getItem("ai_session_id") ||
                    null);

        // ---------- build filters ----------
        // 1) If AI/saved payload already has structured filters → use them
        // 2) Else parse from prompt (works for both structured + simple AI text)
        // ---------- build filters ----------
        let filters = null;

        // 1) Explicit filters in the encrypted payload (best)
        if (
            decrypted?.filters &&
            typeof decrypted.filters === "object" &&
            Object.keys(decrypted.filters).length > 0
        ) {
            // AI shape or manual shape
            filters =
                mapAiFiltersToManual(decrypted.filters) ||
                decrypted.filters;
        }

        // 2) Parse from prompt (saved search structured text / AI text)
        if (!filters) {
            const parsed = parseFiltersFromPrompt(decrypted?.query || "");
            const hasUseful =
                (parsed.titles?.length > 0 &&
                    !String(parsed.titles[0]).includes("below criteria")) ||
                parsed.cities?.length > 0 ||
                parsed.countries?.length > 0 ||
                parsed.seniorities?.length > 0 ||
                parsed.technologies?.length > 0;

            if (hasUseful) {
                filters = parsed;
            }
        }

        // 3) Still nothing, but we have an AI session → send empty object
        //    and rely on backend to use session saved_filters (see Fix 4)
        if (!filters) {
            filters = {
                countries: [],
                states: [],
                cities: [],
                zip_codes: [],
                seniorities: [],
                job_functions: [],
                titles: [],
                companies: [],
                company_sizes: [],
                revenues: [],
                industries: [],
                sic_codes: [],
                technologies: [],
                has_email: null,
                has_phone: null,
            };
        }

        const savedProvider =
            decrypted?.provider ||
            decrypted?.search_data?.provider ||
            null;

        hydrateUiFilters(filters);

        const payload = {
            search_type: "manual",
            use_openai: false,
            filters: filters,
            prompt: decrypted?.query || promptVal || "",
            session_id: sessionToUse,
            run_search: true,
            page: pageToUse,
            page_size: 100,
            provider: savedProvider ? String(savedProvider).toLowerCase() : null,
            provider_page: {},
            mode: resultype === "count" ? "count" : "results",
            uid: parseInt(signInID),
            role: role,
            sbn_id: sbnID,
        };

        if (savedProvider) {
            const p = String(savedProvider).toLowerCase();
            setLastProviderUsed(p);
            sessionStorage.setItem("last_provider_used", p);
        }

        console.log("SAVED / AI SEARCH PAYLOAD =>", payload);



        const requestOption = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        };

        dispatch(loadApolloCount1(requestOption, resultype))
            .then((resp) => {
                if (resultype === "count") {

                    // provider calling
                    const providerUsed =
                        resp.provider_used ||
                        resp.results?.provider_used ||
                        (resp.results?.salestarget?.length ? "salestarget" : null) ||
                        (resp.results?.apollo?.length ? "apollo" : null) ||
                        "salestarget";

                    setLastProviderUsed(providerUsed);
                    sessionStorage.setItem("last_provider_used", providerUsed);

                    setTotalCount(resp.count || 0);
                    dispatch(getToataldataCount(resp.count || 0));
                    if (resp.session_id) {
                        setAiSessionId(resp.session_id);
                        sessionStorage.setItem("ai_session_id", resp.session_id);
                    }
                    setLoading(false);
                } else {
                    const providerUsed =
                        resp.provider_used ||
                        resp.results?.provider_used ||
                        (resp.results?.salestarget?.length ? "salestarget" : null) ||
                        (resp.results?.apollo?.length ? "apollo" : null) ||
                        "salestarget";

                    // ★ ADD THESE TWO LINES
                    setLastProviderUsed(providerUsed);
                    sessionStorage.setItem("last_provider_used", providerUsed);

                    const rawList =
                        (resp.results?.apollo && resp.results.apollo.length
                            ? resp.results.apollo
                            : resp.results?.salestarget) || [];

                    const mergedData = rawList.map((item) => {
                        const matched = viewedContacts.find(
                            (v) => item.id === v.source_id && v.enrich_status === 1
                        );

                        let email = item.email;
                        let hasEmail = item.has_email;

                        if (
                            email === "***@***.com" ||
                            (typeof email === "string" && email.startsWith("***@"))
                        ) {
                            email = null;
                            hasEmail = true;
                        } else if (email) {
                            hasEmail = true;
                        } else {
                            hasEmail = false;
                        }

                        const row = matched
                            ? {
                                ...item,
                                email: matched.email,
                                phone: matched.phone,
                                state: matched.state,
                                city: matched.city,
                                country: matched.country,
                                zipcode: matched.zipcode,
                                saved_status: true,
                                has_email: true,
                            }
                            : {
                                ...item,
                                email,
                                has_email: hasEmail,
                                saved_status: false,
                            };

                        return {
                            ...row,
                            provider: item.provider || providerUsed || "apollo",
                        };
                    });

                    const totalAvailable =
                        resp.pagination?.apollo?.total_available ??
                        resp.pagination?.salestarget?.total_available ??
                        resp.count ??
                        0;

                    setTotalCount(totalAvailable);
                    dispatch(getToataldataCount(totalAvailable));

                    if (resp.session_id) {
                        setAiSessionId(resp.session_id);
                        sessionStorage.setItem("ai_session_id", resp.session_id);
                    }

                    setLoading(false);
                    dispatch(getAisearchedContacts(mergedData));
                    setLoadingSearchContactData(false);
                    setLoadingMore(false);
                }
            })
            .catch((err) => {
                setLoading(false);
                setLoadingSearchContactData(false);
                console.log(err);
            });
    };
    // endregion
    // endregion

    // region handling saving search query modal
    const handleOpenSaveSearch = () => setSaveSearchShowModal(true);

    const handleCloseSaveSearch = () => {
        setSaveSearchShowModal(false);
        setSaveSearchName('');
    };
    // endregion

    // region handle email and mobile status
    const handleEmailChange = (selectedOption) => {
        setHasCompanyEmail(selectedOption);
    };

    const handleMobileChange = (selectedOption) => {
        setHasCompanyMobile(selectedOption);
    };
    // endregion

    // region removing selected item
    const handleRemove = (itemToRemove) => {
        setSelected(selected.filter(item => item !== itemToRemove));

        if (selected.filter(item => item !== itemToRemove).length === 0) {
            setSearch("");
        }
    };
    // endregion

    // region add & remove job titles
    const handleAddJobTitle = () => {
        if (lockedProvider) unlockToDefaultProvider();
        if (loginStatus) {
            scrollToSection("Location")
            setThirdStep(false);
            setForthStep(true);
        }
        const trimmed = jobTitleInput.trim();
        if (trimmed && !jobTitles.includes(trimmed)) {
            setJobTitles([...jobTitles, trimmed]);
        }
        setJobTitleInput('');
    };

    const handleRemoveJobTitle = (titleToRemove) => {
        setJobTitles(jobTitles.filter((title) => title !== titleToRemove));
    };
    // endregion

    // region handle checkbox
    const handleToggle = useCallback((item) => {
        setSelectedFunctions((prev) =>
            prev.includes(item)
                ? prev.filter((val) => val !== item)
                : [...prev, item]
        );

        setTimeout(() => {
            refDataVal.typeaheadRef.current?.toggleMenu();
        }, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderMenuItem = useCallback(
        (option) => (
            <div
                key={option}
                onClick={() => handleToggle(option.toLocaleLowerCase())}
            >
                <Form.Check
                    type="checkbox"
                    id={`checkbox-${option}`}
                    label={option}
                    checked={selectedFunctions.includes(option.toLocaleLowerCase())}
                    onChange={() => { }}
                    style={{ pointerEvents: 'none' }}
                />
            </div>
        ),
        [selectedFunctions, handleToggle]
    );
    // endregion

    // region menu scroll section
    const scrollToSection = (label) => {
        setActiveItem(label);
        const sectionMap = refDataVal.sectionMap

        const ref = sectionMap[label];
        if (ref?.current) {
            Object.values(sectionMap).forEach(r => r?.current?.classList.remove("active"));

            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            ref.current.classList.add("active");
        }
    };
    // endregion

    const [viewResult, setViewResult] = useState(false);
    const [responseTime, setResponseTime] = useState(null);

    // region modify btn finction
    const handleModifySearch = () => {
        const params = new URLSearchParams(location.search);
        params.delete("data");
        setEncryptedData("");

        window.history.replaceState({}, "", `${location.pathname}?${params.toString()}`);

        setEncryptedData("");
        setPage(1)
        setViewResult(false);
        dispatch(getAisearchedContacts([]))
        // setSearchedContactData([])
    }
    // endregion
    const clearSavedSearchContext = () => {
        setParamQuery("");
        setLastProviderUsed(null);
        sessionStorage.removeItem("last_provider_used");
        sessionStorage.removeItem("ai_session_id");
        setAiSessionId(null);
        // if you have useNavigate:
        // navigate("/contact-filter", { replace: true });
    };
    // region get count and data 
    const unlockToDefaultProvider = () => {
        setLockedProvider(null);
        setLastProviderUsed(null);
        sessionStorage.removeItem("last_provider_used");
        setAiSessionId(null);
        sessionStorage.removeItem("ai_session_id");
        setParamQuery("");
    };
    const [countBtnStatus, setCountBtnStatus] = useState(false);
    const searchCount = () => {
        if (loginStatus) {
            setFifthStep(false);
            setSixthStep(true);
        }
        const isFilter = countries.length > 0 || states.length > 0 || cities.length > 0 || zipCodes.length > 0 ||
            selected.length > 0 || selectedFunctions.length > 0 || jobTitles.length > 0 ||
            selectedIndustries.length > 0 || sicCode.length > 0 || companies.length > 0 ||
            selectedTechnology.length > 0 || companySizes.length > 0 || revenues.length > 0 || organizationKeywords.length > 0;

        if (!isFilter) {
            toast.warning(`You have not applied any filters. Can you please select filters below`);
            return;
        }
        setTotalCount(0);
        setViewResult(false);
        setCountBtnStatus(true)
        const newPage = 1;
        setPage(newPage)
        console.log("GET COUNT - CURRENT SESSION =>", aiSessionId);
        apiCallFunction("count", newPage)
    }

    const handleViewResult = () => {
        dispatch(getFirstLoginStatus(false));
        setSelectedRowIds({ type: "include", ids: new Set() });
        setSelectedRowsData([]);

        const newPage = 1;
        setPage(newPage);

        // Coming from AI / saved search
        if (paramQuery?.query || paramQuery?.filters) {
            console.log("VIEW SAVED SEARCH / AI RESULT");
            dispatch(getAisearchedContacts([]));
            const sessionToPass = paramQuery.session_id
                ? paramQuery.session_id
                : null;
            viewDataBySavedSearch("results", paramQuery, 1, sessionToPass);
            return;
        }

        // Manual search flow
        const currentSessionId =
            aiSessionId || sessionStorage.getItem("ai_session_id");

        if (!currentSessionId) {
            console.error("VIEW RESULT ERROR: AI session ID is missing");
            toast.error("Search session expired. Please click Get Count again.");
            return;
        }

        console.log("VIEW RESULT – using session =>", currentSessionId);
        apiCallFunction("results", newPage, currentSessionId);
    };

    const refreshData = () => {
        const newPage = 1;
        setPage(newPage)
        apiCallFunction("results", newPage);
    }

    // useEffect(() => {
    //     if (page !== 1) {
    //         const currentSessionId = aiSessionId || sessionStorage.getItem("ai_session_id");

    //         apiCallFunction("results", page, currentSessionId);
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [page]); 
    useEffect(() => {
        if (page === 1) return; // page 1 is handled by the initial load

        if (paramQuery?.query || paramQuery?.filters) {
            // Keep using the saved-search path for every page
            viewDataBySavedSearch("results", paramQuery, page);
        } else {
            const currentSessionId = aiSessionId || sessionStorage.getItem("ai_session_id");
            apiCallFunction("results", page, currentSessionId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);



    const apiCallFunction = (resultype, pageNum = 1, forcedSessionId = null) => {
        const start = new Date().getTime();

        if (resultype === "count") {
            const isAllEmpty =
                !hasCompanyEmail?.value &&
                !hasCompanyMobile?.value &&
                selected.length === 0 &&
                jobTitles.length === 0 &&
                selectedFunctions.length === 0 &&
                countries.length === 0 &&
                states.length === 0 &&
                cities.length === 0 &&
                zipCodes.length === 0 &&
                companies.length === 0 &&
                companySizes.length === 0 &&
                revenues.length === 0 &&
                selectedIndustries.length === 0 &&
                (!sicCode || String(sicCode).trim() === "") &&
                selectedTechnology.length === 0 &&
                organizationKeywords.length === 0;

            if (isAllEmpty) return;
            setLoading(true);
        }

        if (resultype === "results") {
            console.log("apicallfunction results type")
            setViewResult(true);
            if (pageNum === 1) {
                dispatch(getAisearchedContacts([]));
                setLoadingSearchContactData(true);
            }
        }

        // ----- build prompt from UI filters (keep your existing logic) -----
        const filters = {
            // Location
            countries: countries?.map(i => i.label?.toLowerCase()).filter(Boolean) || [],
            states: states?.map(i => i.label?.toLowerCase()).filter(Boolean) || [],
            cities: cities?.map(i => i.label?.toLowerCase()).filter(Boolean) || [],
            zip_codes: zipCodes || [],

            // People
            seniorities: selected || [],
            job_functions: selectedFunctions || [],
            titles: jobTitles || [],

            // Company
            companies: companies || [],
            company_sizes: companySizes || [],
            revenues: revenues || [],
            industries: selectedIndustries || [],
            sic_codes: Array.isArray(sicCode) ? sicCode : (sicCode ? [sicCode] : []),
            technologies: selectedTechnology || [],
            q_organization_keyword_tags: organizationKeywords || [],

            // Contact info
            has_email: hasCompanyEmail?.value || null,
            has_phone: hasCompanyMobile?.value || null,
        };

        const prompt_ = [
            "Get contacts for below criteria",
            filters.countries.length || filters.states.length || filters.cities.length
                ? `Location: ${[...filters.cities, ...filters.states, ...filters.countries].join(", ")}`
                : "",
            filters.seniorities.length ? `Seniorities: ${filters.seniorities.join(", ")}` : "",
            filters.job_functions.length ? `Job Functions: ${filters.job_functions.join(", ")}` : "",
            filters.titles.length ? `Titles: ${filters.titles.join(", ")}` : "",
            filters.companies.length ? `Companies: ${filters.companies.join(", ")}` : "",
            filters.company_sizes.length ? `Company Size: ${filters.company_sizes.join(", ")}` : "",
            filters.revenues.length ? `Revenue: ${filters.revenues.join(", ")}` : "",
            filters.industries.length ? `Industries: ${filters.industries.join(", ")}` : "",
            filters.sic_codes.length ? `SIC Codes: ${filters.sic_codes.join(", ")}` : "",
            filters.technologies.length ? `Technologies: ${filters.technologies.join(", ")}` : "",
            (filters.q_organization_keyword_tags || []).length
                ? `Organization Keywords: ${filters.q_organization_keyword_tags.join(", ")}`
                : "",
            filters.zip_codes.length ? `Zip Code: ${filters.zip_codes.join(", ")}` : "",
            filters.has_email ? `Having Email: ${filters.has_email}` : "",
            filters.has_phone ? `Having Phone: ${filters.has_phone}` : "",
        ].filter(Boolean).join("\n");

        setPromptVal(prompt_);

        // ----- session -----
        const currentSessionId =
            forcedSessionId ||
            aiSessionId ||
            sessionStorage.getItem("ai_session_id") ||
            null;

        // const providerToSend = (
        //     lastProviderUsed ||
        //     sessionStorage.getItem("last_provider_used") ||
        //     "apollo"
        // ).toLowerCase();
        const isFromSavedOrRecent = Boolean(
            paramQuery?.provider ||
            paramQuery?.search_data?.provider ||
            (location.search && new URLSearchParams(location.search).get("data"))
        );

        const providerToSend = isFromSavedOrRecent
            ? (
                lastProviderUsed ||
                paramQuery?.provider ||
                paramQuery?.search_data?.provider ||
                sessionStorage.getItem("last_provider_used") ||
                null
            )
            : null;

        const payload = {
            search_type: "manual",          // important flag
            use_openai: false,

            filters: filters,               // structured filters
            prompt: prompt_,                // only for logging / display

            session_id: currentSessionId,
            run_search: true,
            page: pageNum,
            page_size: 100,

            // Always both providers for manual search
            provider: providerToSend ? String(providerToSend).toLowerCase() : null,

            mode: resultype === "count" ? "count" : "results",
            uid: parseInt(signInID),
            role: role,
            sbn_id: sbnID,
        };

        console.log("MANUAL SEARCH PAYLOAD =>", payload);



        const requestOption = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        };

        dispatch(loadApolloCount1(requestOption, resultype))
            .then((resp) => {
                const end = new Date().getTime();
                setResponseTime(((end - start) / 1000).toFixed(2));

                if (resultype === "count") {
                    setTotalCount(resp.count || 0);
                    dispatch(getToataldataCount(resp.count || 0));

                    // Provider Calling
                    const providerUsed =
                        resp.provider_used ||
                        resp.results?.provider_used ||
                        (resp.results?.salestarget?.length ? "salestarget" : null) ||
                        (resp.results?.apollo?.length ? "apollo" : null) ||
                        "salestarget";

                    setLastProviderUsed(providerUsed);
                    sessionStorage.setItem("last_provider_used", providerUsed);

                    if (resp.session_id) {
                        setAiSessionId(resp.session_id);
                        sessionStorage.setItem("ai_session_id", resp.session_id);
                    }
                    setLoading(false);
                    setCountBtnStatus(false);
                    const search_payload = {
                        user_id: parseInt(signInID),
                        sbn_id: sbnID,
                        search_data: JSON.stringify({
                            search_criteria: prompt_

                        }),
                        provider: providerUsed
                    }
                    let searchRequest = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(search_payload),
                    };

                    dispatch(postRecentSearchQuery(searchRequest))
                } else {
                    const providerUsed =
                        resp.provider_used ||
                        resp.results?.provider_used ||
                        (resp.results?.salestarget?.length ? "salestarget" : null) ||
                        (resp.results?.apollo?.length ? "apollo" : null) ||
                        "salestarget";

                    setLastProviderUsed(providerUsed);
                    sessionStorage.setItem("last_provider_used", providerUsed);

                    const rawList =
                        (resp.results?.apollo && resp.results.apollo.length
                            ? resp.results.apollo
                            : resp.results?.salestarget) || [];

                    const mergedData = rawList.map((item) => {
                        const matched = viewedContacts.find(
                            (v) => item.id === v.source_id && v.enrich_status === 1
                        );

                        let email = item.email;
                        let hasEmail = item.has_email;

                        if (
                            email === "***@***.com" ||
                            (typeof email === "string" && email.startsWith("***@"))
                        ) {
                            email = null;
                            hasEmail = true;
                        } else if (email) {
                            hasEmail = true;
                        } else {
                            hasEmail = false;
                        }

                        const row = matched
                            ? {
                                ...item,
                                email: matched.email,
                                phone: matched.phone,
                                state: matched.state,
                                city: matched.city,
                                country: matched.country,
                                zipcode: matched.zipcode,
                                saved_status: true,
                                has_email: true,
                            }
                            : {
                                ...item,
                                email,
                                has_email: hasEmail,
                                saved_status: false,
                            };

                        return {
                            ...row,
                            provider: item.provider || providerUsed || "apollo",
                        };
                    });

                    const totalAvailable =
                        resp.pagination?.apollo?.total_available ??
                        resp.pagination?.salestarget?.total_available ??
                        resp.count ??
                        0;

                    setTotalCount(totalAvailable);
                    dispatch(getToataldataCount(totalAvailable));

                    if (resp.session_id) {
                        setAiSessionId(resp.session_id);
                        sessionStorage.setItem("ai_session_id", resp.session_id);
                    }

                    setLoading(false);
                    dispatch(getAisearchedContacts(mergedData));
                    setLoadingSearchContactData(false);
                    setLoadingMore(false);
                }
            })
            .catch((err) => {
                setLoading(false);
                setLoadingSearchContactData(false);
                setCountBtnStatus(false);
                console.log(err);
            });
    };


    // endregion

    // region save search query to db
    const handleSubmitSaveSearchData = () => {
        if (!saveSearchName.trim()) {
            setSaveSearchErrorMessage('Search Name is required');
            return;
        }

        const providerName = (
            lastProviderUsed ||
            sessionStorage.getItem("last_provider_used")).toLowerCase();

        const requestPayload = {
            fk_user_id: parseInt(signInID),
            fk_user_name: userName,
            sbn_id: sbnID,
            saved_search_name: saveSearchName,
            search_data: { query: promptVal, provider: providerName, },
            provider: providerName,
            status: 1
        };

        console.log("SAVE SEARCH PAYLOAD =>", requestPayload);

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };

        dispatch(postSaveSearchData(requestOption, handleCloseSaveSearch));
    };
    // endregion

    const divRef = useRef(null);
    const div1Ref = useRef(null);
    const div2Ref = useRef(null);
    const [height1, setHeight1] = useState(0);
    const [height2, setHeight2] = useState(0);

    // region set table height
    useEffect(() => {
        if (div1Ref.current) {
            setHeight1(div1Ref.current.offsetHeight);
        }
        if (div2Ref.current) {
            setHeight2(div2Ref.current.offsetHeight);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!divRef.current) return;

        const parentHeight = divRef.current.offsetHeight;

        const pixelAdjustment = height1 + height2 + 95;

        const tablePxHeight = parentHeight - pixelAdjustment;

        setTableHeight(tablePxHeight);
    }, [height1, height2, selectedRowsData]);
    // endregion

    const isFilter = countries.length > 0 || states.length > 0 || cities.length > 0 || zipCodes.length > 0 ||
        selected.length > 0 || selectedFunctions.length > 0 || jobTitles.length > 0 ||
        selectedIndustries.length > 0 || sicCode.length > 0 || companies.length > 0 ||
        selectedTechnology.length > 0 || companySizes.length > 0 || revenues.length > 0 || organizationKeywords.length > 0;

    const total_filters = countries.length + states.length + cities.length + zipCodes.length +
        selected.length + selectedFunctions.length + jobTitles.length +
        selectedIndustries.length + sicCode.length + companies.length +
        selectedTechnology.length + companySizes.length + revenues.length + organizationKeywords.length;

    const viewFilters = () => {
        setFilterDiv((prev) => !prev);
    }

    const clearGuideSesion = () => {
        dispatch(getFirstLoginStatus(false))
    }

    // region main return 
    return (
        <div className="page-layout" style={{ position: "relative" }}>
            <AppNavbar />
            {/* loader */}

            {/* loader */}
            <div className="page-content">
                <div className="search-contact-filter-container">
                    {filterDiv &&
                        <div className="lm-filter-summary">
                            <div className="lm-summary-title">
                                Selected Filters
                            </div>
                            <div className="lm-chip-container">
                                {(countries.length > 0 || states.length > 0 || cities.length > 0 || zipCodes.length > 0) &&
                                    <div className="items-div"><span><b>🌍 Location</b></span> <div className="select-items">
                                        {countries?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                {item.label}
                                            </span>
                                        ))}
                                        {states?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                {item.label}
                                            </span>
                                        ))}
                                        {cities?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                {item.label}
                                            </span>
                                        ))}
                                        {zipCodes?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                <i className="fa fa-map-pin"></i> {item}
                                            </span>
                                        ))}
                                    </div></div>
                                }
                                {(selected.length > 0 || selectedFunctions.length > 0 || jobTitles.length > 0) &&
                                    <div className="items-div"><span><b>👤 Titles</b></span> <div className="select-items">
                                        {selected?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                {item}
                                            </span>
                                        ))}
                                        {selectedFunctions?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                {item}
                                            </span>
                                        ))}
                                        {jobTitles?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                {item}
                                            </span>
                                        ))}
                                    </div></div>
                                }
                                {(selectedIndustries.length > 0 || sicCode.length > 0) &&
                                    <div className="items-div"><span><b>🛠️ Indudtries</b></span> <div className="select-items">
                                        {selectedIndustries?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                {item}
                                            </span>
                                        ))}
                                        {sicCode?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                <i className="fa fa-barcode"></i> {item}
                                            </span>
                                        ))}
                                    </div></div>
                                }
                                {(companies.length > 0) &&
                                    <div className="items-div"><span><b>🏬 Companies</b></span> <div className="select-items">
                                        {companies?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                {item}
                                            </span>
                                        ))}
                                    </div></div>
                                }
                                {(selectedTechnology.length > 0) &&
                                    <div className="items-div"><span><b>⚙️ Technologies</b></span> <div className="select-items">
                                        {selectedTechnology?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                {item}
                                            </span>
                                        ))}
                                    </div></div>
                                }
                                {(companySizes.length > 0) &&
                                    <div className="items-div"><span><b>📈 Company Size</b></span> <div className="select-items">
                                        {companySizes?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                <i className="fa fa-users"></i> {item}
                                            </span>
                                        ))}
                                    </div></div>
                                }
                                {(revenues.length > 0) &&
                                    <div className="items-div"><span><b>💼 Revenue</b></span> <div className="select-items">
                                        {revenues?.map((item, index) => (
                                            <span className="lm-chip" key={index}>
                                                <i className="fa fa-line-chart"></i> {item}
                                            </span>
                                        ))}
                                    </div></div>
                                }
                            </div>

                        </div>
                    }
                    <div className="search-contact-filter-container-sidebar" style={{ width: viewResult ? "85px" : "300px" }}>
                        <div style={{ height: '100%', overflow: 'auto' }}>
                            <div className="leadmerge-search-layout">
                                <div className="lm-sidebar">

                                    <div className="lm-sidebar-header">
                                        <h5>Filters</h5>

                                        {/* <span className="lm-filter-count">
                                            {totalCount.toLocaleString()}
                                        </span> */}
                                    </div>

                                    <div className="lm-filter-menu">
                                        {sideMenuItems.map((item) => (
                                            <div
                                                key={item.label}
                                                className={`lm-menu-item ${activeItem === item.label ? "active" : ""
                                                    }`}
                                                onClick={() => scrollToSection(item.label)}
                                            >
                                                <div className="lm-menu-left">
                                                    {/* <img src={item.icon} alt="" /> */}{item.icon}
                                                    <span>{item.label}</span>
                                                </div>

                                                <div className="lm-menu-arrow">
                                                    <i className="fa-solid fa-chevron-right"></i>
                                                </div>
                                            </div>
                                        ))}
                                    </div>



                                    <div className="lm-sidebar-footer">

                                        <div className="lm-selected-count">
                                            {total_filters} Filter(s) Applied
                                        </div>

                                        <button
                                            className="lm-view-btn"
                                            disabled={total_filters === 0}
                                            onClick={viewFilters}
                                        >
                                            {viewResult ? <i className="fa fa-eye"></i> : `View Selected Filters`}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="search-contact-filter-container-second-div" ref={divRef} style={{ width: viewResult ? "calc(100% - 85px)" : "calc(100% - 300px)" }}>
                        <div className="lm-contacts-main">
                            <div className="search-contact-filter-container-second-div-header" ref={div1Ref}>
                                <div>
                                    <div className="search-contact-search-img-div">
                                        <h4>Search Contacts</h4>
                                        <img src={searchImg} alt="search_img" onClick={searchCount} style={{ cursor: "pointer" }} />
                                    </div>
                                    <p>
                                        Configure filters to discover your ideal leads
                                    </p>
                                </div>
                                <div>
                                    <span className="lm-filter-count">
                                        Total Counts: {
                                            loading ? (
                                                <ProgressBar
                                                    animated
                                                    now={100}
                                                    style={{ marginTop: "6px", height: "12px", width: "80px" }}
                                                />
                                            ) : totalCount ? totalCount.toLocaleString() : "0"}
                                    </span>
                                </div>
                            </div>
                            <hr />
                            <div className="main-searc-page">
                                {loading && (
                                    <div className="page-loader">
                                        <div className="loader-content">
                                            <div className="loader-ring"></div>
                                            <h5>Loading...</h5>
                                            <p>Please wait while we prepare your data.</p>
                                        </div>
                                    </div>
                                )}
                                <div className="contacts-btn-section">
                                    <div className="search-contact-filter-container-second-second-div" style={{ width: viewResult ? "20%" : "100%" }}>
                                        <div className="d-flex justify-content-end gap-2 w-100">
                                            {viewResult && <button
                                                className="lm-secondary-btn"
                                                onClick={handleOpenSaveSearch}
                                            >
                                                Save Search
                                            </button>}
                                            <Button
                                                type="button"
                                                className={`btn btn-primary search-view-result-btn ${(loginStatus && fifthStep) && 'guide5-focus-btn'}`}
                                                onClick={searchCount}
                                                disabled={countBtnStatus || total_filters === 0}
                                            >
                                                Get Count
                                            </Button>

                                            {loginStatus && fifthStep && (
                                                <div className="guide-tooltip step5-tooltip">

                                                    <div className="guide-hand">
                                                        👆
                                                    </div>

                                                    <div className="guide-badge">
                                                        Step 5 of 5
                                                    </div>

                                                    <h6>Click on Get Count</h6>

                                                    <p>
                                                        Click on Get Count Buton It will Start fetching the data. Once You get count Go to next step.
                                                    </p>

                                                    <div className="guide-footer">
                                                        <button
                                                            className="guide-skip-btn"
                                                            onClick={clearGuideSesion}
                                                        >
                                                            Skip Tour
                                                        </button>

                                                        <button
                                                            className="guide-next-btn"

                                                            onClick={() => {
                                                                // if (jobTitles.length === 0 && !jobTitleInput){
                                                                //     toast.warning("Type any job title");
                                                                //     return;
                                                                // }
                                                                searchCount();
                                                                setFifthStep(false);
                                                                setSixthStep(true);
                                                            }}
                                                        >
                                                            Next →
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                            <Button
                                                type="button"
                                                className={`btn btn-primary search-view-result-btn ${loginStatus && sixthStep && 'guide5-focus-btn'}`}
                                                onClick={handleViewResult}
                                                disabled={totalCount === 0}
                                            >
                                                View Result
                                            </Button>

                                            {loginStatus && sixthStep && (
                                                <div className="guide-tooltip step6-tooltip">

                                                    <div className="guide-hand">
                                                        👆
                                                    </div>

                                                    <div className="guide-badge">
                                                        Step 6 of 6
                                                    </div>

                                                    <h6>Click on View Contacts</h6>

                                                    <p>
                                                        Click on View Contacts Buton It will Start fetching the data and display.
                                                    </p>

                                                    <div className="guide-footer">
                                                        <button
                                                            className="guide-skip-btn"
                                                            onClick={clearGuideSesion}
                                                        >
                                                            Skip Tour
                                                        </button>

                                                        <button
                                                            className="guide-next-btn"

                                                            onClick={() => {
                                                                setSixthStep(false);
                                                                if (totalCount === 0) {
                                                                    dispatch(getFirstLoginStatus(false))
                                                                } else {
                                                                    handleViewResult()
                                                                }
                                                            }}
                                                        >
                                                            Finish
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {/* <div className="lm-top-actions">
                                            <button
                                                className="lm-secondary-btn"
                                                onClick={handleOpenSaveSearch}
                                            >
                                                Save Search
                                            </button>
                                            <button
                                                className="lm-danger-btn"
                                            >
                                                Clear All
                                            </button>
                                        </div> */}
                                    </div>
                                    {viewResult && <div className="search-contact-filter-container-second-second-div" ref={div2Ref} style={{ width: "80%" }}>
                                        <Row className="align-items-center">
                                            <Col md={4} className="d-flex justify-content-start">
                                                {selectedRowsData?.length > 0 && <span className="selected-count">Selected Contacts: {selectedRowsData?.length}</span>}
                                            </Col>

                                            <Col md={8} className="d-flex justify-content-end">
                                                <div className="d-flex justify-content-end gap-2 w-100">

                                                    {viewResult && (
                                                        <>
                                                            {selectedRowsData?.length >= 1 && <div className='selected-contacts-count-list-btn'>
                                                                <SearchBtn btnName="Add To List" onClickEffect={() => setShowAddToListModal(true)} />
                                                            </div>}
                                                            {/* <Button
                                                            type="button"
                                                            className="btn btn-primary search-view-result-btn"
                                                            onClick={handleModifySearch}
                                                        >
                                                            Modify Search
                                                        </Button> */}
                                                            {/* <Button
                                                            type="button"
                                                            className="btn btn-primary search-view-result-btn"
                                                            onClick={refreshData}
                                                        >
                                                            <i className="fa fa-refresh"></i>
                                                        </Button> */}
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>}
                                </div>
                                <div className="lm-view-section" style={{ padding: '0rem 1rem 1rem' }}>
                                    <div className="contact-filter-div" style={{ width: viewResult ? "20%" : "100%" }}>
                                        <div ref={refDataVal.contactTypeRef} className="search-contact-filter-container-second-third-div active">
                                            <div className="search-contact-filter-container-second-third-inner-div">
                                                <h6>🏢 Contact Level</h6>
                                            </div>
                                            <Form className="search-contact-form-container">
                                                <Row className="mb-3">
                                                    <Col md={viewResult ? 12 : 6}>
                                                        <Form.Group controlId="contactLevel">
                                                            <Form.Label className="pb-2 pt-2">Contact Level</Form.Label>
                                                            <div className="type-head-selected-container">
                                                                {selected.map((item, index) => (
                                                                    <div key={index} className="type-head-selected-options">
                                                                        <span
                                                                            className="cross-mark"
                                                                            onClick={() => handleRemove(item)}
                                                                        >
                                                                            &times;
                                                                        </span>
                                                                        <span style={{ flex: 1 }}>{item}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <Typeahead
                                                                    flip={true}
                                                                    className="w-100"
                                                                    id="contact-level"
                                                                    options={seniorityOptions?.map(opt => opt.label).filter(opt => !selected.includes(opt.toLocaleLowerCase()))}
                                                                    placeholder="Enter job level"
                                                                    onInputChange={(val) => {
                                                                        setSearch(val);
                                                                    }}
                                                                    onChange={(val) => {
                                                                        if (val.length > 0 && !selected.includes(val[0])) {
                                                                            setSelected([...selected, val[0].toLocaleLowerCase()]);
                                                                            setSearch('');
                                                                        }
                                                                    }}
                                                                    selected={[]}
                                                                />
                                                                {/* <Button className="btn btn-primary search-view-result-btn" onClick={openModal}>Browse</Button> */}
                                                            </div>
                                                        </Form.Group>
                                                    </Col>

                                                    {/* Job Title with Browse */}
                                                    <Col md={viewResult ? 12 : 6}>
                                                        <Form.Group controlId="jobTitle">
                                                            <Form.Label className="pb-2 pt-2">Job Title</Form.Label>

                                                            {/* Show added job titles */}
                                                            <div className="type-head-selected-container">
                                                                {jobTitles.map((title, index) => (
                                                                    <div key={index} className="type-head-selected-options">
                                                                        <span
                                                                            className="cross-mark"
                                                                            onClick={() => handleRemoveJobTitle(title)}
                                                                        >
                                                                            &times;
                                                                        </span>
                                                                        <span>{title}</span>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {/* Input and Add button */}
                                                            <div className={`d-flex align-items-center gap-2 ${(loginStatus && thirdStep) && 'guide-focus-input'}`}>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Enter job title"
                                                                    value={jobTitleInput}
                                                                    onChange={(e) => setJobTitleInput(e.target.value)}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === "Enter") {
                                                                            e.preventDefault();
                                                                            handleAddJobTitle();
                                                                        }
                                                                    }}
                                                                />
                                                                <Button
                                                                    className="btn btn-primary search-view-result-btn"
                                                                    onClick={handleAddJobTitle}
                                                                >
                                                                    {viewResult ? <i className="fa fa-plus"></i> : "Add"}
                                                                </Button>

                                                                {loginStatus && thirdStep && (
                                                                    <div className="guide-tooltip step3-tooltip">

                                                                        <div className="guide-right-hand">
                                                                            👉
                                                                        </div>

                                                                        <div className="guide-badge">
                                                                            Step 3 of 6
                                                                        </div>

                                                                        <h6>Enter a Job Title</h6>

                                                                        <p>
                                                                            Type a job title such as <b>CEO</b>, <b>Marketing Manager</b>,
                                                                            or <b>Software Engineer</b> and click <b>Add</b>.
                                                                        </p>

                                                                        <div className="guide-footer">
                                                                            <button
                                                                                className="guide-skip-btn"
                                                                                onClick={clearGuideSesion}
                                                                            >
                                                                                Skip Tour
                                                                            </button>

                                                                            <button
                                                                                className="guide-next-btn"

                                                                                onClick={() => {
                                                                                    setThirdStep(false);
                                                                                    setForthStep(true);
                                                                                    scrollToSection("Location")
                                                                                }}
                                                                            >
                                                                                Next →
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={viewResult ? 12 : 6}>
                                                        <Form.Group controlId="jobFunction">
                                                            <Form.Label className="pb-2 pt-2">Job Function</Form.Label>

                                                            {/* Show selected items above */}
                                                            <div className="type-head-selected-container">
                                                                {selectedFunctions.map((item, index) => (
                                                                    <div key={index} className="type-head-selected-options d-flex mb-1">
                                                                        <span
                                                                            className="cross-mark me-2"
                                                                            onClick={() => handleToggle(item)}
                                                                        >
                                                                            &times;
                                                                        </span>
                                                                        <span>{item}</span>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {/* Typeahead with checkbox in dropdown and flicker-free behavior */}
                                                            <Typeahead
                                                                flip={true}
                                                                id="job-function-typeahead"
                                                                ref={refDataVal.typeaheadRef}
                                                                multiple
                                                                selected={[]}
                                                                onChange={() => { }}
                                                                // options={loadingJobFunctionDropdown ? ['Loading data...'] : jobFunctionDropdown.map(option => option.label)} // Only passing the 'label' property
                                                                options={jobfunctionOptions.map(option => option.label)} // Only passing the 'label' property
                                                                placeholder="Enter your search"
                                                                renderMenuItemChildren={renderMenuItem}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={viewResult ? 12 : 6}>
                                                        <Form.Group>
                                                            <Form.Label className="pb-2 pt-2">Has Company Email</Form.Label>
                                                            <Select
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                                options={radioOptions}
                                                                placeholder="Select"
                                                                value={hasCompanyEmail}
                                                                onChange={handleEmailChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={viewResult ? 12 : 6}>
                                                        <Form.Group>
                                                            <Form.Label className="pb-2 pt-2">Has Company Mobile</Form.Label>
                                                            <Select
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                                options={radioOptions}
                                                                placeholder="Select"
                                                                value={hasCompanyMobile}
                                                                onChange={handleMobileChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </div>
                                        <div ref={refDataVal.locationRef}>
                                            <Location
                                                countries={countries}
                                                setCountries={setCountries}
                                                cities={cities}
                                                setCities={setCities}
                                                states={states}
                                                setStates={setStates}
                                                zipCodes={zipCodes}
                                                setZipCodes={setZipCodes}
                                                zipInput={zipInput}
                                                setZipInput={setZipInput}
                                                search={search}
                                                setSearch={setSearch}
                                                searchState={searchState}
                                                setSearchState={setSearchState}
                                                viewResult={viewResult}
                                                forthStep={forthStep}
                                                setForthStep={setForthStep}
                                                setFifthStep={setFifthStep}
                                            />
                                        </div>
                                        <div ref={refDataVal.companyRef}>
                                            <Company
                                                companies={companies}
                                                setCompanies={setCompanies}
                                                companyInput={companyInput}
                                                setCompanyInput={setCompanyInput}
                                                companySizes={companySizes}
                                                setCompanySizes={setCompanySizes}
                                                companySizeFrom={companySizeFrom}
                                                setCompanySizeFrom={setCompanySizeFrom}
                                                companySizeTo={companySizeTo}
                                                setCompanySizeTo={setCompanySizeTo}
                                                revenues={revenues}
                                                setRevenues={setRevenues}
                                                revenueFrom={revenueFrom}
                                                setRevenueFrom={setRevenueFrom}
                                                revenueTo={revenueTo}
                                                setRevenueTo={setRevenueTo}
                                                viewResult={viewResult}
                                            />
                                        </div>
                                        <div ref={refDataVal.industryRef}>
                                            <Industry
                                                selectedIndustries={selectedIndustries}
                                                setSelectedIndustries={setSelectedIndustries}
                                                sicCode={sicCode}
                                                setSicCode={setSicCode}
                                                subIndustry={subIndustry}
                                                setSubIndustry={setSubIndustry}
                                                search={searchSubIndustry}
                                                setSearch={setSearchSubIndustry}
                                                showModal={showModal1}
                                                setShowModal={setShowModal1}
                                                viewResult={viewResult}
                                            />
                                        </div>
                                        <div ref={refDataVal.technologyRef}>
                                            <Technologies
                                                selected={selectedTechnology}
                                                setSelected={setSelectedTechnology}
                                                search={searchTechnoloy}
                                                setSearch={setSearchTechnology}
                                                showModal={showModal2}
                                                setShowModal={setShowModal2}
                                                viewResult={viewResult}
                                                organizationKeywords={organizationKeywords}
                                                setOrganizationKeywords={setOrganizationKeywords}
                                            />
                                        </div>
                                    </div>
                                    {viewResult && <div className="contact-result-div" style={{ width: "80%" }}>
                                        <SelectedSearchFilterTable
                                            setPage={setPage}
                                            loadingSearch={loadingSearchContactData}
                                            searchContactData={AisearchedContacts}
                                            totalDataCount={totalDataCount}
                                            selectedSort={selectedSort}
                                            viewResult={viewResult}
                                            loading={loading}
                                            responseTime={responseTime}
                                            // fetchSearchContact={fetchSearchContact}
                                            loadingMore={loadingMore}
                                            setLoadingMore={setLoadingMore}
                                            tableHeight={tableHeight}
                                            selectedRowsData={selectedRowsData}
                                            setSelectedRowsData={setSelectedRowsData}
                                            setShowAddToListModal={setShowAddToListModal}
                                            showAddToListModal={showAddToListModal}
                                            selectedRowIds={selectedRowIds}
                                            setSelectedRowIds={setSelectedRowIds}
                                        />
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <SaveSearchModal
                saveSearchShowModal={saveSearchShowModal}
                handleCloseSaveSearch={handleCloseSaveSearch}
                signInDetails={signInDetails}
                saveSearchName={saveSearchName}
                setSaveSearchName={setSaveSearchName}
                handleSubmitSaveSearchData={handleSubmitSaveSearchData}
                saveSearchErrorMessage={saveSearchErrorMessage}
                setSaveSearchErrorMessage={setSaveSearchErrorMessage}
            />
        </div>
    )
    // endregion
}

export default ContactFilterCategories;

